import SEO from "@/components/SEO";
import { FadeUp, SectionTag, MaskedLines } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

const Block = ({ title, children, id }) => (
  <FadeUp>
    <section data-testid={id} className="border-b border-sand/70 py-10">
      <h2 className="font-serif text-2xl">{title}</h2>
      <div className="mt-4 space-y-3 leading-relaxed text-stone">{children}</div>
    </section>
  </FadeUp>
);

const Impressum = () => (
  <div data-testid="impressum-page">
    <SEO
      title="Impressum | Daviz & Puxi – Freie Trauung Deluxe"
      description="Impressum und Anbieterkennzeichnung von Freie Trauung Deluxe – Marc Hofmeister, Krefeld. Freie Redner für individuelle Zeremonien."
      path="/impressum"
    />

    <section className="mx-auto max-w-3xl px-5 pb-24 pt-36 sm:px-8 sm:pt-44">
      <FadeUp>
        <SectionTag>Rechtliches</SectionTag>
      </FadeUp>
      <MaskedLines lines={["Impressum"]} className="mt-6 font-serif text-5xl sm:text-7xl" delay={0.15} />

      <div className="mt-14">
        <Block title="Angaben gemäß § 5 TMG" id="impressum-angaben">
          <p>
            Marc Hofmeister<br />
            Freie Trauung Deluxe – Mark Daviz & Angela Puxi<br />
            Pottbäckerstr. 17<br />
            47839 Krefeld
          </p>
        </Block>
        <Block title="Kontakt" id="impressum-kontakt">
          <p>
            Mobil: +49 (0) 171 534 01 05<br />
            E-Mail: {CONTACT.email}
          </p>
        </Block>
        <Block title="Bankverbindung" id="impressum-bank">
          <p>
            Kontoinhaber: Marc Hofmeister<br />
            Bank: Deutsche Bank<br />
            IBAN: DE10 3807 0024 0035 0868 00<br />
            BIC: DEUTDEDB380
          </p>
        </Block>
        <Block title="Steuerliche Angaben" id="impressum-steuer">
          <p>
            Steuernummer: 205/5126/1839<br />
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: 205/5126/183
          </p>
        </Block>
        <Block title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV" id="impressum-verantwortlich">
          <p>
            Marc Hofmeister<br />
            Pottbäckerstr. 17<br />
            47839 Krefeld
          </p>
        </Block>
        <Block title="Haftung für Inhalte" id="impressum-haftung">
          <p>
            Die Inhalte dieser Seiten wurden mit großer Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
          </p>
        </Block>
        <Block title="Haftung für Links" id="impressum-links">
          <p>
            Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
            Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
            verantwortlich.
          </p>
        </Block>
      </div>
    </section>
  </div>
);

export default Impressum;
